// Copyright aptihealth, inc. 2019 All Rights Reserved

import a5ScreeningRequests from "./a5Screening";
import adminRequests from "./admin";
import { assessmentRequestsTyped } from "./assessmentTyped";
import authRequests from "./auth";
import { carePlanRequests } from "./care_plan";
import featureFlagRequests from "./featureFlag";
import messagingRequests from "./messaging";
import metricsRequests from "./metrics";
import obfuscationRequests from "./obfuscation";
import patientRequests from "./patient";
import { patientRequestsTyped } from "./patientTyped";
import paymentRequests from "./payment";
import providerRequests from "./provider";
import { providerRequestsTyped } from "./providerTyped";
import publicRequests from "./public";
import { publicRequestsTyped } from "./publicTyped";
import scheduleRequests from "./schedule";
import searchRequests from "./search";
import sharedRequests from "./shared";
import { sharedRequestsTyped } from "./sharedTyped";
import trackingRequests from "./tracking";
import workflowRequests from "./workflow";
import workingHourRequests from "./workingHours";

export const api = {
  a5Screening: a5ScreeningRequests,
  admin: adminRequests,
  assessmentTyped: assessmentRequestsTyped,
  auth: authRequests,
  carePlan: carePlanRequests,
  featureFlag: featureFlagRequests,
  messaging: messagingRequests,
  metrics: metricsRequests,
  obfuscation: obfuscationRequests,
  patient: patientRequests,
  patientTyped: patientRequestsTyped,
  payment: paymentRequests,
  provider: providerRequests,
  providerTyped: providerRequestsTyped,
  public: publicRequests,
  publicTyped: publicRequestsTyped,
  schedule: scheduleRequests,
  search: searchRequests,
  shared: sharedRequests,
  sharedTyped: sharedRequestsTyped,
  tracking: trackingRequests,
  workflow: workflowRequests,
  workingHours: workingHourRequests,
};
